import React, { Component } from "react";
import {
  Container,
  Navbar,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  NavbarToggler,
  NavbarBrand,
} from "reactstrap";
import { Link } from "react-router-dom";
import ScrollspyNav from "./scrollSpy";

//Import Stickey Header
import StickyHeader from "react-sticky-header";

import logolight from "../../assets/images/logo/horizontal.svg";
import logodark from "../../assets/images/logo/horizontal.svg";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";

class NavbarPage extends Component {
  prevScrollpos = 0;

  state = {
    contactVisible: false
  }

  showContact() {
    this.setState({ contactVisible: true });
  }

  hideContact() {
    this.setState({ contactVisible: false });
  }

  constructor(props) {
    super(props);
    this.state = {
      navItems: [
        { id: 1, to: "/dermatologists", navheading: "Our dermatologists" },
        // { id: 2, to: "/for-dermatologists", navheading: "For dermatologists" },
        // { id: 2, to: "/blog", navheading: "Resources" },
        // { id: 3, to: "/contact", navheading: "Contact" },
      ],
      isOpen: false,
      topPos: "0",
      isOpenMenu: false,
      navCenterClass: "",
    };
    this.toggleLine = this.toggleLine.bind(this);

    this.handleScrollMenu = this.handleScrollMenu.bind(this);
  }

  handleScrollMenu = async () => {
    let currentScrollPos = window.pageYOffset;
    if (this.prevScrollpos > currentScrollPos) {
      await this.setState({ topPos: "0" });
    } else {
      await this.setState({ topPos: "-420px" });
    }
    this.prevScrollpos = currentScrollPos;

    if (window.innerWidth <= 768) {
      await this.setState({ navCenterClass: "" });
    } else {
      await this.setState({
        navCenterClass: "navbar-nav mx-auto navbar-center",
      });
    }
  };

  componentDidMount() {
    this.prevScrollpos = window.pageYOffset;
    window.addEventListener("scroll", this.handleScrollMenu);
    if (window.innerWidth <= 768) {
      this.setState({ navCenterClass: "" });
    } else {
      this.setState({ navCenterClass: "navbar-nav mx-auto navbar-center" });
    }
    window.scrollTo(0, 0)
  }

  toggleLine() {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  }

  toggle = async () => {
    await this.setState({ isOpenMenu: !this.state.isOpenMenu });
  };

  render() {
    let navStyles = { top: 0}
    let buttonClasses = 'btn btn-outline-light btn-login btn-login-main'
    if (this.props.withLine == 'true')
    {
      navStyles = { top: 0, borderBottom: '1px solid #eeeeee', backgroundColor: '#ffffff' }
      buttonClasses = 'btn btn-outline-derma btn-login  btn-login-main'
    }
    return (
      <React.Fragment>

            <Navbar
              className={`navbar navbar-expand-lg navbar-custom pt-3 pb-3 ${
                this.props.isStickyNav === true
                  ? ``
                  : ``
              }`}
              id="navbar"
              style={navStyles}
            >
              <Container className="pl-0">
                <NavbarBrand href="/" className="logo">
                  <img
                    src={this.props.imglight ? logolight : logodark}
                    alt=""
                    className="logo-light position-relative"
                    height={60}
                    style={{top: 4}}
                  />
                </NavbarBrand>

                <NavbarToggler
                  className="navbar-toggler"
                  type="button"
                  aria-label="Toggle navigation"
                  onClick={this.toggle}
                >
                  <i className="remixicon-menu-fill" />
                </NavbarToggler>
                <Collapse
                  id="navbarCollapse"
                  isOpen={this.state.isOpenMenu}
                  navbar
                >

                  <Nav
                    navbar
                    className="navbar-nav mx-auto navbar-center"
                    id="mySidenav"
                  >
                    {this.state.navItems.map((item, key) => (
                      <NavItem
                        key={key}
                        className={
                          item.navheading === "Home"
                            ? "nav-item active"
                            : "nav-item"
                        }
                      >
                        <NavLink href={item.to} className="nav-link">
                          {" "}
                          {item.navheading}
                        </NavLink>
                      </NavItem>
                    ))}
                    <NavItem
                      key="3"
                      className="nav-item"
                    >
                      <NavLink href="#contact" onClick={this.showContact.bind(this)} className="nav-link">
                        {" "}
                        Contact
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <a className={buttonClasses} style={{borderRadius: '10px', padding: '10px 15px 10px 15px'}} href="/login">Log in to Dr. Derma</a>
                </Collapse>
              </Container>
            </Navbar>

        <Modal className="contactus" center="true" open={this.state.contactVisible} onClose={this.hideContact.bind(this)}>
          <h4>Contact us</h4>
          <hr />
          <div className="row">
            <div className="col-12">
              <p class="text-dark-gray">
                For support, questions or feedback, please feel free to get in contact
              </p>
              <div>
                <ul className="list-group">
                  <li className="list-group-item m-0 p-0 border-0 text-dark-gray">
                    <i className="remixicon-mail-line mr-2" style={{fontSize: 22}}></i>
                    <a href="mailto:support@drderma.co.za?subject=New%20Support%20Ticket" className="position-relative d-inline-block text-dark-gray" style={{top: -2}}>support@drderma.co.za</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="footer-about-content mt-4">
                <ul className="list-inline footer-icon mt-4">
                  <li className="list-inline-item h4 mr-4">
                    <a className="text-muted-light" target="_blank" href="https://www.facebook.com/drderma.southafrica">
                      <i className="remixicon-facebook-line"></i>
                    </a>
                  </li>
                  <li className="list-inline-item h4 mr-4">
                    <a className="text-muted-light" target="_blank" href="https://www.instagram.com/dr_derma_sa">
                      <i className="remixicon-instagram-line"></i>
                    </a>
                  </li>
                  <li className="list-inline-item h4 mr-4">
                    <a className="text-muted-light" target="_blank" href="https://www.linkedin.com/company/dr-derma-southern-africa/">
                      <i className="remixicon-linkedin-line"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

export default NavbarPage;
